import React from 'react'
import { match } from 'ts-pattern'

import type { ISignUpData } from '@/contexts/AppUIModalContext/hooks/ui-modal'

import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'
import SignInForm from '@/pages/tad.ai/sign-in/_blocks/SignInForm'
import SignUpForm from '@/pages/tad.ai/sign-up/_blocks/SignUpForm'

export interface ISignUpBoxProps extends ISignUpData {
  className?: string
  defaultShowSignUp?: boolean
  signUpWarperClassName?: string
}

const SignUpBox: React.FC<ISignUpBoxProps> = (props) => {
  const {
    className,
    onSignUpSuccess,
    onSignInSuccess,
    readOnlyEmail,
    defaultShowSignUp = true,
    signUpWarperClassName,
  } = props

  const [showSignUp, setShowSignUp] = React.useState(defaultShowSignUp)
  const { isSignIn } = useSessionInfo()

  useEffect(() => {
    if (isSignIn) {
      onSignInSuccess?.()
    }
  }, [isSignIn, onSignInSuccess])

  return (
    <div
      className={tw`
        border-f-border w-fit
        rounded-[12px] border
        ${className}
      `}
    >
      {match(showSignUp)
        .with(true, () => {
          return (
            <SignUpForm
              titleAs={'div'}
              readOnlyEmail={readOnlyEmail}
              formContainerClassName={cls`w-full max-w-full`}
              onSignUpSuccess={() => {
                onSignUpSuccess?.()
              }}
              handleClickLogIn={() => {
                setShowSignUp(false)
              }}
              className={cls``}
              warperClassName={signUpWarperClassName}
            />
          )
        })
        .otherwise(() => {
          return (
            <SignInForm
              titleAs={'div'}
              readOnlyEmail={readOnlyEmail}
              formContainerClassName={cls`w-full max-w-full`}
              onSignInSuccess={() => {}}
              handleClickSignUp={() => {
                setShowSignUp(true)
              }}
              className={cls``}
            />
          )
        })}
    </div>
  )
}

export default SignUpBox
